import { TABLE_CELL_MARKER_UTILITIES, UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";
import { TABLE_SORT_ROWS_AUX_FUNCTIONS } from "../util/classes";
import { TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS } from "../util/classes";
import { DOM_AUX_FUNCTIONS } from "../util/classes";
import { CMP } from "../util/cmp";
import { SMART_CMP } from "../util/smart_cmp";

export class SYS_Bus100 {

    // ----------------------------------------
    // משתני ניווט
    // ----------------------------------------

    public static VAR_CURRENT_ROW: number = 0;
    public static VAR_CURRENT_COLUMN: number = 0;

    // ----------------------------------------
    // סימון השורה והתא הנוכחיים
    // ----------------------------------------

    public static ADD_MARK_TO_CURRENT_ROW(): void {
        const table_obj = SYS_Bus100.create_table_object();

        TABLE_CELL_MARKER_UTILITIES.PAINT_ROW(
            table_obj.table_element,
            SYS_Bus100.VAR_CURRENT_ROW,
            "#abcdef",
            "black"
        );

        TABLE_CELL_MARKER_UTILITIES.PAINT_CELL_GIVEN_ROW_AND_COLUMN(
            table_obj.table_element,
            SYS_Bus100.VAR_CURRENT_ROW,
            SYS_Bus100.VAR_CURRENT_COLUMN,
            "blue",
            "white"
        );
    }

    public static REMOVE_MARK_FROM_CURRENT_ROW(): void {
        const table_obj = SYS_Bus100.create_table_object();

        TABLE_CELL_MARKER_UTILITIES.RESTORE_ROW(
            table_obj.table_element,
            SYS_Bus100.VAR_CURRENT_ROW
        );
    }

    // ----------------------------------------
    // ניווט בטבלה
    // ----------------------------------------

    public static ADJ_UP(): void {
        if (SYS_Bus100.VAR_CURRENT_ROW > 0) {
            SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

            SYS_Bus100.VAR_CURRENT_ROW -= 1;

            SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus100.SCROLL_TO_CELL_INA();
        }
    }

    public static ADJ_DOWN(): void {
        const table_obj = SYS_Bus100.create_table_object();

        const number_of_rows =
            TABLE.trans_table_element_to_number_of_rows(
                table_obj.table_element
            );

        if (SYS_Bus100.VAR_CURRENT_ROW < (number_of_rows - 1)) {
            SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();
            SYS_Bus100.VAR_CURRENT_ROW += 1;
            SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus100.SCROLL_TO_CELL_INA();
        }
    }

    public static ADJ_LEFT(): void {
        const table_obj = SYS_Bus100.create_table_object();

        const number_of_columns =
            TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW(
                table_obj.table_element,
                SYS_Bus100.VAR_CURRENT_ROW
            );

        if (SYS_Bus100.VAR_CURRENT_COLUMN < (number_of_columns - 1)) {
            SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

            SYS_Bus100.VAR_CURRENT_COLUMN += 1;

            SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus100.SCROLL_TO_CELL_INA();
        }
    }

    public static ADJ_RIGHT(): void {
        if (SYS_Bus100.VAR_CURRENT_COLUMN > 0) {
            SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

            SYS_Bus100.VAR_CURRENT_COLUMN -= 1;

            SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
            SYS_Bus100.SCROLL_TO_CELL_INA();
        }
    }

    public static ADJ_NEXT(): void {
        for (let i = 0; i < 20; i++) {
            SYS_Bus100.ADJ_UP();
        }
    }

    public static ADJ_PRIOR(): void {
        for (let i = 0; i < 20; i++) {
            SYS_Bus100.ADJ_DOWN();
        }
    }

    public static ADJ_HOME(): void {
        SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

        SYS_Bus100.VAR_CURRENT_COLUMN = 0;

        SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus100.SCROLL_TO_CELL_INA();
    }

    public static ADJ_CONTROL_HOME(): void {
        SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

        SYS_Bus100.VAR_CURRENT_ROW = 0;
        SYS_Bus100.VAR_CURRENT_COLUMN = 0;

        SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus100.SCROLL_TO_CELL_INA();
    }

    public static ADJ_END(): void {
        const table_obj = SYS_Bus100.create_table_object();

        const number_of_columns =
            TABLE.trans_table_element_to_number_of_columns(
                table_obj.table_element
            );

        SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

        const last_col = number_of_columns - 1;
        SYS_Bus100.VAR_CURRENT_COLUMN = last_col;

        SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus100.SCROLL_TO_CELL_INA();
    }

    public static ADJ_CONTROL_END(): void {
        const table_obj = SYS_Bus100.create_table_object();

        const number_of_rows =
            TABLE.trans_table_element_to_number_of_rows(
                table_obj.table_element
            );

        SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

        SYS_Bus100.VAR_CURRENT_ROW = number_of_rows - 1;

        // מעדיפים את העמודה הראשונה
        const first_col = 0;
        SYS_Bus100.VAR_CURRENT_COLUMN = first_col;

        SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus100.SCROLL_TO_CELL_INA();
    }

    // ----------------------------------------
    // אירועי מקלדת
    // ----------------------------------------

    public static keydown_event_should_preventDefault(
        event: KeyboardEvent
    ): boolean {

        if (event.key === "Escape") return true;
        if (event.key === "Insert") return true;
        if (event.key === "Delete") return true;
        if (event.key === "ArrowUp") return true;
        if (event.key === "ArrowDown") return true;
        if (event.key === "ArrowLeft") return true;
        if (event.key === "ArrowRight") return true;
        if (event.key === "PageUp") return true;
        if (event.key === "PageDown") return true;
        if (event.key === "Home") return true;
        if (event.key === "End") return true;
        if (event.key === "F1") return true;
        if (event.key === "F2") return true;
        if (event.key === "F3") return true;
        if (event.key === "F4") return true;
        if (event.key === "F6") return true;

        return false;
    }

    public static async keydown(
        event: KeyboardEvent
    ): Promise<void> {

        if (UTL.modal_is_opened == true || UTL.block_everything == true) {
            return;
        }

        if (
            SYS_Bus100.keydown_event_should_preventDefault(event) == true
        ) {
            event.preventDefault();
        }

        if (event.key === "Insert") {
            debugger;
        }

        if (event.key === "Delete") {
        }

        if (event.key === "F2") {
        }

        if (event.key === "F3") {
        }

        if (event.key === "F4") {
        }

        if (event.key === "F1") {
            alert("F1 ready to use");
        }

        if (event.key === "F6") {
        }

        if (event.key === "Enter") {
        }

        if (event.key === "Escape") {
        }

        if (event.key === "ArrowUp") {
            SYS_Bus100.ADJ_UP();
        }

        if (event.key === "ArrowDown") {
            SYS_Bus100.ADJ_DOWN();
        }

        if (event.key === "ArrowLeft") {
            SYS_Bus100.ADJ_LEFT();
        }

        if (event.key === "ArrowRight") {
            SYS_Bus100.ADJ_RIGHT();
        }

        if (event.key === "PageUp") {
            SYS_Bus100.ADJ_NEXT();
        }

        if (event.key === "PageDown") {
            SYS_Bus100.ADJ_PRIOR();
        }

        if (event.key === "Home") {
            if (event.ctrlKey == false) {
                SYS_Bus100.ADJ_HOME();
            }

            if (event.ctrlKey == true) {
                SYS_Bus100.ADJ_CONTROL_HOME();
            }
        }

        if (event.key === "End") {
            if (event.ctrlKey == false) {
                SYS_Bus100.ADJ_END();
            }

            if (event.ctrlKey == true) {
                SYS_Bus100.ADJ_CONTROL_END();
            }
        }
    }

    // ----------------------------------------
    // יצירת אובייקט הטבלה
    // ----------------------------------------

    public static create_table_object(): TableObject {
        const table_obj: TableObject = new TableObject();

        table_obj.table_element =
            document.getElementById("id-table") as HTMLTableElement;

        table_obj.taco_element = document.getElementById("id-taco");
        table_obj.has_vertical_scroll = true;
        table_obj.has_horizontal_scroll = true;
        table_obj.exist_head = true;
        table_obj.exist_numerator = false;
        table_obj.direction = "rtl";

        return table_obj;
    }

    public static SCROLL_TO_CELL_INA(): void {
        const table_obj = SYS_Bus100.create_table_object();

        TBLSCROLLER.scroll_to_cell_INA(
            table_obj,
            SYS_Bus100.VAR_CURRENT_ROW,
            SYS_Bus100.VAR_CURRENT_COLUMN
        );
    }

    public static TABLE_mousedown(event: MouseEvent): void {
        if (UTL.block_everything == true) {
            return;
        }

        const target_element = event.target as HTMLElement;

        const row_number =
            TABLE.trans_mouse_target_to_row_number(target_element);

        const column_number =
            TABLE.trans_mouse_target_to_column_number(target_element);

        if (row_number != (-1) && column_number != (-1)) {
            SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

            SYS_Bus100.VAR_CURRENT_ROW = row_number;
            SYS_Bus100.VAR_CURRENT_COLUMN = column_number;

            SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
        }
    }

    public static myload(): void {
        const table_obj = SYS_Bus100.create_table_object();

        table_obj.table_element.addEventListener(
            "mousedown",
            SYS_Bus100.TABLE_mousedown
        );

        document.addEventListener(
            "keydown",
            SYS_Bus100.keydown
        );

        SYS_Bus100.VAR_CURRENT_ROW = 0;
        SYS_Bus100.VAR_CURRENT_COLUMN = 0;

        SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
        SYS_Bus100.SCROLL_TO_CELL_INA();
    }

    // ----------------------------------------
    // משתני מיון
    // ----------------------------------------

    public static VAR_SORT_columnIndex: number = -1;
    public static VAR_SORT_last_sort_column: number = -1;
    public static VAR_SORT_sort_ascending_flag: boolean = true;

    // ----------------------------------------
    // מיון הטבלה
    // ----------------------------------------

    public static compare_strings_by_column(
        p_str1: string,
        p_str2: string
    ): number {

        const diff = SMART_CMP.COMPARE(p_str1, p_str2, false);

        return diff;
    }

    public static compare_table_rows_by_column(
        row_element1: HTMLTableRowElement,
        row_element2: HTMLTableRowElement
    ): number {

        const text1: string =
            row_element1.cells[
                SYS_Bus100.VAR_SORT_columnIndex
            ].innerText;

        const text2: string =
            row_element2.cells[
                SYS_Bus100.VAR_SORT_columnIndex
            ].innerText;

        const diff: number =
            SYS_Bus100.compare_strings_by_column(
                text1,
                text2
            );

        if (SYS_Bus100.VAR_SORT_sort_ascending_flag == true) {
            return diff;
        }
        else {
            return -diff;
        }
    }

    public static init_all_sort_icons(): void {
        const allHeaders: NodeListOf<HTMLTableCellElement> =
            document.querySelectorAll("th");

        for (let i: number = 0; i < allHeaders.length; i++) {
            const header: HTMLTableCellElement = allHeaders[i];

            const icon: HTMLElement =
                header.querySelector(".cl-th-sort-element");

            if (icon !== null) {
                icon.innerHTML = "↕";
            }
        }
    }

    public static updateSortIcon(
        th: HTMLTableCellElement,
        is_ascending: boolean
    ): void {

        SYS_Bus100.init_all_sort_icons();

        const icon: HTMLElement =
            th.querySelector(".cl-th-sort-element");

        if (icon !== null) {
            if (is_ascending == true) {
                icon.innerHTML = "▲";
            }
            else {
                icon.innerHTML = "▼";
            }
        }
    }

    public static sort_table_given_th_element(
        th_element: HTMLTableCellElement
    ): void {

        SYS_Bus100.REMOVE_MARK_FROM_CURRENT_ROW();

        const columnIndex: number = th_element.cellIndex;

        SYS_Bus100.VAR_SORT_columnIndex = columnIndex;

        const table_element: HTMLTableElement =
            document.getElementById("id-table") as HTMLTableElement;

        if (table_element === null) {
            throw new Error("Table element not found");
        }

        th_element.dataset.sortDirection = "desc";

        if (SYS_Bus100.VAR_SORT_last_sort_column === columnIndex) {
            SYS_Bus100.VAR_SORT_sort_ascending_flag =
                !SYS_Bus100.VAR_SORT_sort_ascending_flag;
        }
        else {
            SYS_Bus100.VAR_SORT_last_sort_column = columnIndex;

            SYS_Bus100.VAR_SORT_sort_ascending_flag = true;
        }

        SYS_Bus100.updateSortIcon(
            th_element,
            SYS_Bus100.VAR_SORT_sort_ascending_flag
        );

        TABLE_SORT_ROWS_AUX_FUNCTIONS.sortTable(
            table_element,
            SYS_Bus100.compare_table_rows_by_column
        );

        SYS_Bus100.ADD_MARK_TO_CURRENT_ROW();
    }
}

// ----------------------------------------
// Wrapper לשמירת הממשק הקיים
// ----------------------------------------

export const SYS_Bus100_wrapper = {
    SYS_Bus100_myload: SYS_Bus100.myload,
    SYS_Bus100_sort_table_given_th_element:
        SYS_Bus100.sort_table_given_th_element
};
